const template = `
<div class="race-analysis-outer-container">
  <div class="race-analysis-container">

    <div class="race-analysis-top">
      <div class="race-analysis-top-bar">
        <div class="stripes"></div>
        <button type="button" class="close"/>
      </div>
      <ul class="race-analysis-navigation">
        <li data-sticky-template="race-analysis-navigation-item" data-id="%raceNumber%"><span>%numberOfRaces%</span></li>
      </ul>
    </div>

    <div class="race-analysis-loader loader loader--visible loader--with-light-bg loader--cover">
      <div class="loader__inner">
        <div class="spinner"></div>
        <h1>&nbsp;</h1>
      </div>
    </div>

    <div class="scroll-container">

      <div class="race-analysis-header">
        <div class="race-details">
          <span class="type"></span>
          <span class="header"></span>
        </div>
      </div>

      <div class="content-container">
        <div class="sections">
          <div data-sticky-template="race-analysis-section">
            <h2 class="heading"></h2>
            <div class="body"></div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
`;

export default template;
